import gql from 'graphql-tag';

const ITEM_FRAGMENT =
  ` fragment itemFields on ShoppingListItem {
      id
      foodItemId
      description
      externalId
    }
  `;

const CHECK_ITEM_RESULT_FRAGMENT =
  ` fragment checkItemResultFields on ShoppingListCheckItemResult {
      id
      item {
        ...itemFields
      }
      modifiedAt
      newIndex
    }
    ${ITEM_FRAGMENT}`;

const UNCHECK_ITEM_RESULT_FRAGMENT =
  ` fragment uncheckItemResultFields on ShoppingListUncheckItemResult {
      id
      item {
        ...itemFields
      }
      modifiedAt
      newIndex
    }
    ${ITEM_FRAGMENT}`;

const ADD_ITEMS_RESULT_FRAGMENT =
  ` fragment addItemsResultFields on ShoppingListAddItemsResult {
      id
      list {
        ...itemFields
      }
      modifiedAt
    }
    ${ITEM_FRAGMENT}`;

const ADD_ITEM_RESULT_FRAGMENT =
  ` fragment addItemResultFields on ShoppingListAddItemResult {
      id
      item {
        ...itemFields
      }
      index
      modifiedAt
    }
    ${ITEM_FRAGMENT}`;

const CHANGE_ITEM_RESULT_FRAGMENT =
  ` fragment changeItemResultFields on ShoppingListChangeItemResult {
      id
      item {
        ...itemFields
      }
      modifiedAt
      itemListName
    }
    ${ITEM_FRAGMENT}`;

const DELETE_ITEM_RESULT_FRAGMENT =
  ` fragment deleteItemResultFields on ShoppingListDeleteItemResult {
      id
      itemId
      modifiedAt
      itemListName
    }`;

const CLEAR_ALL_RESULT_FRAGMENT =
  ` fragment clearAllResultFields on ShoppingListClearAllResult {
      id
      modifiedAt
    }`;

const MOVE_ITEM_RESULT_FRAGMENT =
  ` fragment moveItemResultFields on ShoppingListMoveItemResult {
      id
      list {
        ...itemFields
      }
      modifiedAt
      itemListName
    }
    ${ITEM_FRAGMENT}`;

const UPDATE_NAME_RESULT_FRAGMENT =
  ` fragment updateNameResultFields on ShoppingListUpdateNameResult {
      id
      name
      modifiedAt
    }`;

const SHOPPING_LIST_FRAGMENT =
  ` fragment shoppingListFields on ShoppingList {
      id
      name
      access
      modifiedAt
      items {
        checked {
          ...itemFields
        }
        unchecked {
          ...itemFields
        }
      }
    }
    ${ITEM_FRAGMENT}`;

const LIST_QUERY =
  gql`query ShoppingList($id: ID!) {
    shoppingList(id: $id) {
      ...shoppingListFields
    }
  }
  ${SHOPPING_LIST_FRAGMENT}`;

const CHECK_ITEM =
  gql`mutation ShoppingListCheckItem($id: ID!, $itemId: ID!, $newIndex: Int) {
    shoppingListCheckItem(id: $id, itemId: $itemId, newIndex: $newIndex) {
      item {
        ...itemFields
      }
      modifiedAt
    }
  }
  ${ITEM_FRAGMENT}`;

const UNCHECK_ITEM =
  gql`mutation ShoppingListUncheckItem($id: ID!, $itemId: ID!, $newIndex: Int) {
    shoppingListUncheckItem(id: $id, itemId: $itemId, newIndex: $newIndex) {
      item {
        ...itemFields
      }
      modifiedAt
    }
  }
  ${ITEM_FRAGMENT}`;

const CHANGE_ITEM =
  gql`mutation ShoppingListChangeItem($id: ID!, $itemId: ID!, $newDescription: String!, $itemListName: SHOPPING_ITEM_LIST) {
    shoppingListChangeItem(id: $id, itemId: $itemId, newDescription: $newDescription, itemListName: $itemListName) {
      item {
        ...itemFields
      }
      modifiedAt
    }
  }
  ${ITEM_FRAGMENT}`;

const DELETE_ITEM =
  gql`mutation ShoppingListDeleteItem($id: ID!, $itemId: ID!, $itemListName: String!) {
    shoppingListDeleteItem(id: $id, itemId: $itemId, itemListName: $itemListName) {
      itemId
      modifiedAt
    }
  }`;

const ADD_ITEM =
  gql`mutation ShoppingListAddItem($id: ID!, $item: ShoppingListItemInput!, $index: Int, $itemListName : SHOPPING_ITEM_LIST) {
    shoppingListAddItem(id: $id, item: $item, index: $index, itemListName: $itemListName) {
      item {
        ...itemFields
      }
      modifiedAt
    }
  }
  ${ITEM_FRAGMENT}`;

const ADD_ITEMS =
  gql`mutation ShoppingListAddItems($items: [ShoppingListItemInput!]!) {
    shoppingListAddItems(items: $items) {
      list {
        ...itemFields
      }
      modifiedAt
    }
  }
  ${ITEM_FRAGMENT}`;

const MOVE_ITEM =
  gql`mutation ShoppingListMoveItem($id: ID!, $itemId: ID!, $newIndex: Int!, $itemListName: SHOPPING_ITEM_LIST!) {
    shoppingListMoveItem(id: $id, itemId: $itemId, newIndex: $newIndex, itemListName: $itemListName) {
      list {
        ...itemFields
      }
      modifiedAt
    }
  }
  ${ITEM_FRAGMENT}`;

const CLEAR_ALL =
  gql`mutation ShoppingListClearAll($id: ID!) {
    shoppingListClearAll(id: $id) {
      id
      modifiedAt
    }
  }`;

const NEW_LIST =
  gql`mutation ShoppingListCreateNew($name: String!) {
    shoppingListCreateNew(name: $name) {
      id
    }
  }`;

const DELETE_LIST =
  gql`mutation ShoppingListDelete($id: ID!) {
    shoppingListDelete(id: $id) {
      deletedList {
        name
      }
      defaultList {
        id
      }
    }
  }`;

const UPDATE_NAME =
  gql`mutation ShoppingListUpdateName($id: ID!, $name: String!) {
    shoppingListUpdateName(id: $id, name: $name) {
      id
      name
      modifiedAt
    }
  }`;

const LISTS_QUERY =
  gql`{
    shoppingLists {
      id
      name
      modifiedAt
    }
  }`;

const CHANGED =
  gql`subscription ShoppingListChanged($id: ID!) {
    shoppingListChanged(id: $id) {
      __typename
      ...checkItemResultFields,
      ...uncheckItemResultFields,
      ...addItemsResultFields,
      ...addItemResultFields,
      ...changeItemResultFields,
      ...deleteItemResultFields,
      ...clearAllResultFields,
      ...moveItemResultFields,
      ...updateNameResultFields,
    }
  }
  ${CHECK_ITEM_RESULT_FRAGMENT}
  ${UNCHECK_ITEM_RESULT_FRAGMENT}
  ${ADD_ITEMS_RESULT_FRAGMENT}
  ${ADD_ITEM_RESULT_FRAGMENT}
  ${CHANGE_ITEM_RESULT_FRAGMENT}
  ${DELETE_ITEM_RESULT_FRAGMENT}
  ${CLEAR_ALL_RESULT_FRAGMENT}
  ${MOVE_ITEM_RESULT_FRAGMENT}
  ${UPDATE_NAME_RESULT_FRAGMENT}`;

export {
  ITEM_FRAGMENT,
  LIST_QUERY,
  LISTS_QUERY,
  CHECK_ITEM,
  UNCHECK_ITEM,
  CHANGE_ITEM,
  DELETE_ITEM,
  ADD_ITEM,
  ADD_ITEMS,
  MOVE_ITEM,
  CLEAR_ALL,
  NEW_LIST,
  DELETE_LIST,
  UPDATE_NAME,

  CHANGED,
};



// WEBPACK FOOTER //
// ./src/graphql/shopping-list.js